export {ariaHideOutside} from '../../../src/overlays/ariaHideOutside';
